import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { MobileIcon, OnCall, TechName, TechType } from './atoms';
import { Label, NoPropertyAssigned, TechAddress, TechImage, TechReview } from './molecules';
import { ColumnWrapper, FlexWrapper, Wrapper, MobileHeaderWrapper, MobileImageWrapper } from './wrappers';
import { TechAchievements } from 'containers';
import { Icon } from 'atoms';
import moment from 'moment';
import { FlexCenterWrapper, GenericWrapper, Ml4 } from 'wrappers';
import { AwardSvg, PercentageSvg, StarSvg, CoinSvg } from 'components/icons';
import internalState from './internalState';

export const mobileDefinition = {
  name: "TechCard",
  controller: Controller,
  initialProps: ({ tech, properties, loadingStats, showCoins }) => ({ tech, properties, loadingStats, showCoins }),
  props: internalState,
  elements: [
    {
      wrapper: Wrapper,
      isButton: true,
      bindings: ({ tech }) => ({ tech }),
      name: 'TechCard',
      elements: [
        {
          wrapper: MobileHeaderWrapper,
          name: 'TechImage',
          elements: [
            {
              component: wrap(TechImage, MobileImageWrapper),
              name: 'TechImage',
              bindings: ({ tech }) => ({ tech })
            },
            {
              component: TechAchievements,
              name: 'TechAchievements',
              bindings: ({ tech, loadingStats }) => ({ stats: tech.stats, loading: loadingStats })
            }
          ]
        },
        {
          component: OnCall,
          name: 'IsOnCall',
          renderIf: ({ tech }) => tech.on_calls_count > 0,
          displayValue: ({ }) => 'On Call'
        },
        {
          wrapper: ColumnWrapper,
          name: 'TechInfo',
          elements: [
            {
              component: TechType,
              name: 'TechType',
              displayValue: ({ tech }) => tech.type
            },
            {
              component: TechName,
              name: 'TechName',
              displayValue: ({ tech }) => tech.name
            },
            {
              component: NoPropertyAssigned,
              name: 'NoPropertyAssigned',
              renderIf: ({ tech, properties }) => properties.filter(property => tech.property_ids.some(id => id === property.id)).length === 0,
              bindings: ({ }) => ({})
            },
            {
              component: TechAddress,
              name: 'TechAddress',
              renderIf: ({ tech, properties }) => properties.filter(property => tech.property_ids.some(id => id === property.id)).length > 0,
              bindings: ({ tech, properties }) => ({ properties: properties.filter(property => tech.property_ids.some(id => id === property.id)).map(property => property.name) }),
              displayState: ({ tech, properties }) => ({ showPopup: properties.filter(property => tech.property_ids.some(id => id === property.id)).length > 1 })
            },
            {
              wrapper: FlexWrapper,
              name: 'RatingAndStats',
              elements: [
                {
                  wrapper: GenericWrapper,
                  name: 'Rating',
                  elements: [
                    {
                      component: Label,
                      name: 'Label',
                      bindings: ({ tech }) => {
                        const activationDeactivationDate = tech.active ? (tech.activated_at ?? tech.inserted_at) : (tech.deactivated_at ?? tech.inserted_at);
                        return {
                          active: tech.active, text: `${tech.active ? 'Active' : 'Disabled'} since ${moment(activationDeactivationDate).local().format('MM/DD/YYYY')}${!tech.active && tech.deactivated_by ? ` by ${tech.deactivated_by}` : ''}`
                        }
                      },
                      displayState: ({ tech }) => ({ active: tech.active })
                    },
                    {
                      wrapper: FlexWrapper,
                      name: 'Rating',
                      elements: [
                        {
                          component: Icon,
                          name: 'RatingStars',
                          displayValue: ({ }) => StarSvg({ width: '18', height: '18', filled: true })
                        },
                        {
                          component: TechReview,
                          name: 'TechReview',
                          bindings: ({ tech }) => ({ rating: `${Math.floor(tech.stats?.rating ?? 0)}/5`, review: tech.stats?.reviews ?? 0 }),
                          displayState: ({ tech }) => ({ showPopup: tech.name.length > 1 })
                        },
                        {
                          component: wrap(Icon, Ml4),
                          name: 'CoinIcon',
                          renderIf: ({ showCoins }) => showCoins,
                          displayValue: ({ }) => CoinSvg({ width: '16', height: '16' })
                        },
                        {
                          component: TechReview,
                          name: 'CoinText',
                          renderIf: ({ showCoins }) => showCoins,
                          bindings: ({ tech }) => ({ rating: `${(tech.coins ?? 0).toLocaleString()} coins` }),
                        },
                      ]
                    },
                  ]
                },
                {
                  wrapper: FlexCenterWrapper,
                  name: 'Stats',
                  elements: [
                    {
                      component: MobileIcon,
                      name: 'Top',
                      renderIf: ({ tech }) => tech.top && tech.top > 0,
                      displayValue: ({ tech }) => AwardSvg({ top: tech.top })
                    },
                    {
                      component: MobileIcon,
                      name: 'Percentage',
                      renderIf: ({ tech }) => tech.stats.completion_time,
                      displayValue: ({ tech }) => {
                        let displayTime = '';

                        if (tech.stats?.completion_time) {
                          let duration = moment.duration(tech.stats?.completion_time, "seconds");
                          if (duration.seconds() >= 1) {
                            displayTime = `${Math.floor(duration.seconds())}s`;
                          }
                          if (duration.minutes() >= 1) {
                            displayTime = `${Math.floor(duration.minutes())}m`;
                          }
                          if (duration.hours() >= 1) {
                            displayTime = `${Math.floor(duration.hours())}h`;
                          }
                          if (duration.days() >= 1) {
                            displayTime = `${Math.floor(duration.days())}d`;
                          }
                        }

                        return PercentageSvg({ averageTime: displayTime });
                      }
                    }
                  ]
                },
              ]
            }
          ]
        }
      ]
    }
  ]
}

const MobileTechCard = ContainerComponent(mobileDefinition)

export default MobileTechCard
